(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var top, bar, hero;
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var h = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    document.body.classList.toggle('mf-scrolled', y > 40);
    if (top) top.classList.toggle('is-on', y > 600);
    if (bar) bar.style.width = Math.min(100, (y / h) * 100) + '%';
    if (hero && !reduce && window.innerWidth > 749 && y < 1200) {
      hero.style.transform = 'translate3d(0,' + Math.round(y * 0.18) + 'px,0)';
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    top = document.createElement('div');
    top.className = 'mf-top';
    top.setAttribute('role', 'button');
    top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = '&#8593;';
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    document.body.appendChild(top);
    bar = document.createElement('div');
    bar.className = 'mf-progress';
    document.body.appendChild(bar);
    hero = document.querySelector('.slideshow-wrapper .hero');
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.index-section:not(.index-section--hero), .mf-section');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mf-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('mf-reveal');
      io.observe(el);
    });
    window.setTimeout(function () {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('mf-in'); });
    }, 5000);
  });
})();
